export const SUPPORT_LANGUAGES = {
    FI: 'fi',
    SV: 'sv',
    EN: 'en',
};

export const STORAGE_LANG_KEY = 'i18nextLng';